

const vadeStockoutSaleProductPage = /\/products\/(whey-isolate-protein|plant-based-meal-replacement|vade-nutrition-blenderbottle-classic-loop-top-shaker-bottle-28oz)(?:[/?#]|$)/.test(window.location.pathname);

if (!vadeStockoutSaleProductPage) {

     
// ============main js start for product page  selected price update ================

$(document).ready(function () {
  // Handle variant label click
  $(document).on('click', 'label[for^="template-"]', function () {

    // Delay the triggering of the "One-Time Purchase" label click by 100ms
    setTimeout(function () {
      $('.cstm-js-price-itg label.skio-group-label.one-time-purchase').click();
      // $(".cstm-js-price-itg .product__info-wrapper .product-form__submit span").text('one-time-purchase');
    }, 100); // Adjust time if necessary
  });
});



$(document).ready(function () {
  const parsePrice = (priceString) => {
    const priceNumber = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    return isNaN(priceNumber) ? 0 : priceNumber;
  };

  const updatePrices = (labelSelector, buttonPrefix) => {
    const priceElement = $(`${labelSelector} .skio-price span`);
    if (priceElement.length === 0) return;

    const price = priceElement.text().trim();
    const tipri = `${buttonPrefix} - `; //${price}

    // Update button text
    $(".cstm-js-price-itg .product__info-wrapper .product-form__submit span").text(tipri);

    // Calculate discounted price
    const priceNumber = parsePrice(price);
    const discountedPrice = (priceNumber * 0.9).toFixed(2);

    // Update displayed prices
    $(".cstm-js-price-itg span.as.prodprice").text(`$${discountedPrice}`);
    $(".cstm-js-price-itg .price-item.price-item--regular").text(price);

  };

  // Handle "Subscribe & Save" click
  $(document).on('click', '.cstm-js-price-itg label.skio-group-label.subscribe-save', function () {
    updatePrices('.cstm-js-price-itg label.skio-group-label.subscribe-save', "SUBSCRIBE & SAVE");
    $('.prodprice').addClass('active'); // Activate specific styling
     $('.one-time-price').addClass('hidden');
    $('.subscribe-price').removeClass('hidden');
  });

  // Handle "One-Time Purchase" click
  $(document).on('click', '.cstm-js-price-itg label.skio-group-label.one-time-purchase', function () {
    updatePrices('.cstm-js-price-itg label.skio-group-label.one-time-purchase', "ONE-TIME PURCHASE");
    $('.prodprice').removeClass('active'); // Deactivate specific styling
    $('.one-time-price').removeClass('hidden');
    $('.subscribe-price').addClass('hidden');
  });

  // Initial Price Update (if needed on load)
  const initialPriceElement = $('.cstm-js-price-itg label.skio-group-label.subscribe-save .skio-price span');
  if (initialPriceElement.length) {
    const initialPrice = initialPriceElement.text().trim();
    const tipri = "SUBSCRIBE & SAVE - "; //initialPrice
    $(".cstm-js-price-itg .product__info-wrapper .product-form__submit span").text(tipri);

    const priceNumber = parsePrice(initialPrice);
    const discountedPrice = (priceNumber * 0.9 + 0.01).toFixed(2);

    $(".cstm-js-price-itg span.as.prodprice").text(`$${discountedPrice}`);
    $(".cstm-js-price-itg .price-item.price-item--regular").text(initialPrice);
   
  }
});




$(document).ready(function () {
  // Function to update visibility based on selected input value
  const updatePriceVisibility = () => {
    const selectedInput = $('.skio-plan-picker input[type="radio"]:checked'); // Get checked input
    const selectedValue = selectedInput.val();

    if (selectedValue === "") {
      // If value is empty, show subscribe-price
      $('.subscribe-price').addClass('hidden');
      $('.one-time-price').removeClass('hidden');
    } else {
      // If value exists, show one-time-price
      $('.subscribe-price').removeClass('hidden');
      $('.one-time-price').addClass('hidden');
    }
  };

  // Initial visibility check on page load
  updatePriceVisibility();
});








// // collection page Choose options open modal js  selected  price show 


document.addEventListener("DOMContentLoaded", () => {
  const targetSelector = '.quick-add-modal__content-info.gradient.color-scheme-2';

  const parsePrice = (priceString) => {
    const priceNumber = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    return isNaN(priceNumber) ? 0 : priceNumber;
  };

  const updatePrices = (labelSelector, buttonPrefix, context = '') => {
    const priceElement = document.querySelector(`${context} ${labelSelector} .skio-price span`);
    if (!priceElement) return;

    const price = priceElement.textContent.trim();
    const tipri = `${buttonPrefix} - ${price}`;

    // Update button text
    const buttonTextElement = document.querySelector(`${context} .product-form__submit span`);
    if (buttonTextElement) buttonTextElement.textContent = tipri;

    // Calculate discounted price
    const priceNumber = parsePrice(price);
    const discountedPrice = (priceNumber * 0.9).toFixed(2);

    // Update displayed prices
    const prodPriceElement = document.querySelector(`${context} span.as.prodprice`);
    const regularPriceElement = document.querySelector(`${context} .price-item.price-item--regular`);

    if (prodPriceElement) prodPriceElement.textContent = `$${discountedPrice}`;
    if (regularPriceElement) regularPriceElement.textContent = price;

  };

  const initializePrices = () => {
    const initialPriceElement = document.querySelector(`${targetSelector} label.skio-group-label.subscribe-save .skio-price span`);
    if (initialPriceElement) {
      const initialPrice = initialPriceElement.textContent.trim();
      const tipri = "SUBSCRIBE & SAVE - " + initialPrice;

      const buttonTextElement = document.querySelector(`${targetSelector} .product-form__submit span`);
      if (buttonTextElement) buttonTextElement.textContent = tipri;

      const priceNumber = parsePrice(initialPrice);
      const discountedPrice = (priceNumber * 0.9 + 0.01).toFixed(2);

      const prodPriceElement = document.querySelector(`${targetSelector} span.as.prodprice`);
      const regularPriceElement = document.querySelector(`${targetSelector} .price-item.price-item--regular`);

      if (prodPriceElement) prodPriceElement.textContent = `$${discountedPrice}`;
      if (regularPriceElement) regularPriceElement.textContent = initialPrice;
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        if (document.querySelector(targetSelector)) {
          initializePrices();

          // Handle "Subscribe & Save" click
          document.querySelector(`${targetSelector} label.skio-group-label.subscribe-save`)?.addEventListener('click', () => {
            updatePrices('label.skio-group-label.subscribe-save', "SUBSCRIBE & SAVE", targetSelector);
            document.querySelector('.prodprice')?.classList.add('active');
          });

          // Handle "One-Time Purchase" click
          document.querySelector(`${targetSelector} label.skio-group-label.one-time-purchase`)?.addEventListener('click', () => {
            updatePrices('label.skio-group-label.one-time-purchase', "ONE-TIME PURCHASE", targetSelector);
            document.querySelector('.prodprice')?.classList.remove('active');
          });

          observer.disconnect(); // Stop observing after initializing
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});




document.addEventListener('DOMContentLoaded', function () {
  // Check if we are inside the modal view
  function isModalView() {
    return document.querySelector('.quick-add-modal__content-info.gradient.color-scheme-2') !== null;
  }

  // Apply the short code logic
  function applyShortCode(variantId) {
    const shortCodeElement = document.querySelector('[data-short-code]');
    if (shortCodeElement) {
      const shortCodeText = `Short Code: ${variantId}`;
      shortCodeElement.textContent = shortCodeText;
    }
  }

  // Handle the variant change event
  function onVariantChange(event) {
    const variantId = event.target.value; // Assuming the variant id is in the value of the selected option

    if (isModalView()) {
      applyShortCode(variantId); // Apply short code if in modal
    }
  }

  // Listen for variant selection changes (assuming select element for variants)
  const variantSelects = document.querySelectorAll('select[name="variant"]'); // Adjust the selector based on your markup
  variantSelects.forEach((select) => {
    select.addEventListener('change', onVariantChange);
  });
});






document.addEventListener('DOMContentLoaded', function () {
  // Check if we are inside the modal view
  function isModalView() {
    return document.querySelector('.quick-add-modal__content-info.gradient') !== null;
  }

  // Handle variant label click
  document.querySelectorAll('label[for^="template-"]').forEach(label => {
    label.addEventListener('click', function () {

      // Only proceed if we are inside the modal view
      if (isModalView()) {
        
        // Delay the triggering of the "One-Time Purchase" label click by 100ms
        setTimeout(function () {
          const oneTimePurchaseLabel = document.querySelector('.cstm-js-price-itg label.skio-group-label.one-time-purchase');
          if (oneTimePurchaseLabel) {
            oneTimePurchaseLabel.click();
          }
        }, 100); // Adjust time if necessary
      } else {
      }
    });
  });
});






document.addEventListener('DOMContentLoaded', function () {
  // Check if we are inside the modal view
  function isModalView() {
    return document.querySelector('.quick-add-modal__content-info.gradient.color-scheme-2') !== null;
  }

  if (isModalView()) {
    const parsePrice = (priceString) => {
      const priceNumber = parseFloat(priceString.replace(/[^0-9.]/g, ''));
      return isNaN(priceNumber) ? 0 : priceNumber;
    };

    const updatePrices = (labelSelector, buttonPrefix) => {
      const priceElement = document.querySelector(`${labelSelector} .skio-price span`);
      if (!priceElement) return;

      const price = priceElement.textContent.trim();
      const tipri = `${buttonPrefix} - `; //${price}

      // Update button text
      const buttonText = document.querySelector(".cstm-js-price-itg .product__info-wrapper .product-form__submit span");
      if (buttonText) buttonText.textContent = tipri;

      // Calculate discounted price
      const priceNumber = parsePrice(price);
      const discountedPrice = (priceNumber * 0.9).toFixed(2);

      // Update displayed prices
      const prodPrice = document.querySelector(".cstm-js-price-itg span.as.prodprice");
      const regularPrice = document.querySelector(".cstm-js-price-itg .price-item.price-item--regular");
      if (prodPrice) prodPrice.textContent = `$${discountedPrice}`;
      if (regularPrice) regularPrice.textContent = price;

    };

    // Handle "Subscribe & Save" click
    document.querySelector('.cstm-js-price-itg label.skio-group-label.subscribe-save').addEventListener('click', function () {
      updatePrices('.cstm-js-price-itg label.skio-group-label.subscribe-save', "SUBSCRIBE & SAVE");
      document.querySelectorAll('.prodprice').forEach(el => el.classList.add('active')); // Activate specific styling
    });

    // Handle "One-Time Purchase" click
    document.querySelector('.cstm-js-price-itg label.skio-group-label.one-time-purchase').addEventListener('click', function () {
      updatePrices('.cstm-js-price-itg label.skio-group-label.one-time-purchase', "ONE-TIME PURCHASE");
      document.querySelectorAll('.prodprice').forEach(el => el.classList.remove('active')); // Deactivate specific styling
    });

    // Initial Price Update (if needed on load)
    const initialPriceElement = document.querySelector('.cstm-js-price-itg label.skio-group-label.subscribe-save .skio-price span');
    if (initialPriceElement) {
      const initialPrice = initialPriceElement.textContent.trim();
      const tipri = "SUBSCRIBE & SAVE - "; //initialPrice
      const buttonText = document.querySelector(".cstm-js-price-itg .product__info-wrapper .product-form__submit span");
      if (buttonText) buttonText.textContent = tipri;

      const priceNumber = parsePrice(initialPrice);
      const discountedPrice = (priceNumber * 0.9 + 0.01).toFixed(2);

      const prodPrice = document.querySelector(".cstm-js-price-itg span.as.prodprice");
      const regularPrice = document.querySelector(".cstm-js-price-itg .price-item.price-item--regular");
      if (prodPrice) prodPrice.textContent = `$${discountedPrice}`;
      if (regularPrice) regularPrice.textContent = initialPrice;
    }
  }
});







// ======================== tempalte index js=================



 //var subs  = document.querySelector('.group-container:frist-child');










 
}
